import { useLoading } from '../../contexts/LoadingContext';
import { useQuery } from 'react-query';
import { useZoneContext } from '../../contexts/useZoneContext';

export const useExpertsList = (enableLoader?: boolean) => {
    const loading = useLoading();
    const { zoneApiClient } = useZoneContext();

    return useQuery({
        queryKey: ['get-experts-list'],
        queryFn: async () => {
            if (enableLoader) {
                loading.showLoading();
            }

            const response = await zoneApiClient.getExperts();
            const sorted = response.payload?.sort((a, b) =>
                a.lastName.toLowerCase() < b.lastName.toLowerCase() ? -1 : 1
            );

            return sorted;
        },
        onSettled: enableLoader ? () => loading.hideLoading() : undefined,
        staleTime: 1 * 60 * 1000,
    });
};
